export default __webpack_public_path__ + "static/media/trezilogowhite.d4b96cf9.png";